module.exports = __webpack_public_path__ + "img/27-ABITO-IMBRONCIATO-U-COLORI-LINO-COLORI-GARZA-STAMPE-LINO-7.48ea39b7.jpg";